import React from "react";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";

const NoPlan = () => {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  return (
    <div>
      <div className="row  bg-white bordertop fixed-top">
        <div className="container-fluid d-flex justify-content-between align-itmes-center">
          <a className="navbar-brand me-auto" href="#">
            {" "}
            <img src="assets/img/RDocs.png" className="logo" alt="logo" />
          </a>
        </div>
      </div>
      <div className="container-login100" style={{ minHeight: "100vh" }}>
        <img
          className="wave"
          src="assets/img/wave_yellow.svg"
          style={{ color: "f2d8da" }}
          alt="Wave"
        />
        <div className="d-flex flex-column align-items-center ">
          <img
            src="assets/img/URLRestriction1.png"
            className="logoSendToRdoc"
            alt="logo"
          />
          <div className="UrlRestrictBoxTexts">
            <p className="mb-0 text1 App">
            No subscription plan is assigned for this account.
            </p>
            <p className="mb-1 App">
            Please contact your company administrator.
            </p>
          </div>
          <div className="UrlRestrictBoxTexts"></div>

          <div className="checkbox clearfix d-flex align-items-center justify-content-between">
            <div
              className="form-check checkbox-theme justify-content-center ps-1 w-50 "
              style={{ textAlign: "left" }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NoPlan;
